module.exports = __webpack_public_path__ + "static/media/placaj-brikston-antichizat-nevada.0dcc0bee.gif";